import React from 'react'
import TopCollections from '../TopCollections/TopCollections'

const Collections = () => {
  return (
    <div>
      <TopCollections/>
    </div>
  )
}

export default Collections
